import {
  ACTUAL_IMPLEMENTATION,
  ACTUAL_IMPLEMENTATION_LABEL,
  ANALYTICS,
  BRANCH_INDICATORS_REPORT,
  BRANCH_INDICATORS_REPORT_LABEL,
  DETAILS_OF_EXPENSES,
  DETAILS_OF_EXPENSES_LABEL,
  DIRECTION_INDICATORS,
  DIRECTION_INDICATORS_LABEL,
  EXPENSE_BY_ARTICLES_REPORT,
  EXPENSE_BY_ARTICLES_REPORT_LABEL,
  FINANCIAL_RESULTS_REPORT,
  FINANCIAL_RESULTS_REPORT_LABEL,
  ORGANIZATION_CLIENTS_GROWTH,
  ORGANIZATION_CLIENTS_GROWTH_LABEL,
  REVENUE_STATEMENT,
  REVENUE_STATEMENT_LABEL,
  SALARY_REPORT,
  SALARY_REPORT_LABEL,
} from '@app/constants';

export const getAnalyticsReportTitle = (activeTab: string | null) => {
  switch (activeTab) {
    case ANALYTICS:
      return 'Главная';
    case DIRECTION_INDICATORS:
      return DIRECTION_INDICATORS_LABEL;
    case ORGANIZATION_CLIENTS_GROWTH:
      return ORGANIZATION_CLIENTS_GROWTH_LABEL;
    case FINANCIAL_RESULTS_REPORT:
      return FINANCIAL_RESULTS_REPORT_LABEL;
    case REVENUE_STATEMENT:
      return REVENUE_STATEMENT_LABEL;
    case ACTUAL_IMPLEMENTATION:
      return ACTUAL_IMPLEMENTATION_LABEL;
    case DETAILS_OF_EXPENSES:
      return DETAILS_OF_EXPENSES_LABEL;
    case EXPENSE_BY_ARTICLES_REPORT:
      return EXPENSE_BY_ARTICLES_REPORT_LABEL;
    case BRANCH_INDICATORS_REPORT:
      return BRANCH_INDICATORS_REPORT_LABEL;
    case SALARY_REPORT:
      return SALARY_REPORT_LABEL;
    default:
      return '';
  }
};
